import React from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import SemiCircleProgressBar from 'react-progressbar-semicircle'
import { SORT_METRIC_BY_VEHICLE_UPDATED } from '../query/metric'

class RemainingFuelComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: this.dataMetrics(this.props.sort_metrics)
    }
  }

  componentWillReceiveProps (nextProps) {
    // Update data when sort_metrics prop changes (from polling)
    if (nextProps.sort_metrics !== this.props.sort_metrics) {
      this.setState({
        data: this.dataMetrics(nextProps.sort_metrics)
      })
    }
  }

  // componentDidMount () {
  //   const self = this
  //   let trbImm = self.props.trbImm
  //   this.props.subscribeToMore({
  //     document: SORT_METRIC_BY_VEHICLE_UPDATED,
  //     variables: {
  //       jsonFilter: {
  //         'trb_imm': trbImm
  //       }
  //     },
  //     updateQuery: (prev, {
  //       subscriptionData
  //     }) => {
  //       if (!subscriptionData.data) {
  //         return prev
  //       } else {
  //         this.setState({
  //           data: self.dataMetrics(subscriptionData.data.latest_metrics)
  //         })
  //         return {
  //           latest_metrics: subscriptionData.data.latest_metrics
  //         }
  //       }
  //     }
  //   })
  // }

  dataMetrics (metrics) {
    let dataFuel = []
    metrics.forEach(function (element, key) {
      let values = {}
      for (let tag in element) {
        if (tag === 'metadata') {
          for (let subTag in element[tag]) {
            values[subTag] = metrics[key][tag][subTag]
          }
        } else {
          values[tag] = element[tag]
        }
      }
      dataFuel.push(values)
    })
    return dataFuel
  }

  getPercentage (volume, tankCapacity) {
    let percentage = (volume * 100) / tankCapacity
    return (percentage)
  }

  render () {
    let volume = this.state.data[0].value
    let tankCapacity = this.state.data[0].tank_capacity
    return (
      <div>
        <div style={styles.paper}>
          <LinesEllipsis
            style={styles.title}
            text='CARBURANT RESTANT'
            maxLine='1'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
          <div style={styles.content}>
            <SemiCircleProgressBar
              stroke='#7ED321'
              strokeWidth={35}
              background='#21262A'
              percentage={this.getPercentage(volume, tankCapacity)}
              diameter={250} />
          </div>
          <div style={styles.contentLabel}>
            <span style={styles.label}>{volume ? volume.toFixed(0) : '-'}<span style={styles.unit}> L</span></span>
          </div>
          <div style={styles.contentNumbers}>
            <span style={styles.zero}>0</span>
            <span style={styles.tankCapacity}>{tankCapacity}</span>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  paper: {
    textAlign: 'left',
    backgroundColor: '#374147',
    height: '380px',
    borderRadius: '16px',
    paddingTop: '12px'
  },
  title: {
    marginLeft: '24px',
    marginTop: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  content: {
    textAlign: 'center',
    width: '100%',
    height: '80px',
    marginTop: '62px'
  },
  contentLabel: {
    marginTop: '2px',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    height: '42px',
    width: '250px'
  },
  label: {
    fontSize: '42px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  },
  unit: {
    fontSize: '14px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  },
  contentNumbers: {
    marginTop: '4px',
    marginLeft: 'auto',
    marginRight: 'auto',
    height: '42px',
    width: '250px'
  },
  zero: {
    fontSize: '14px',
    color: '#FFFFFF',
    fontWeight: 'bold',
    marginLeft: '26px'
  },
  tankCapacity: {
    fontSize: '14px',
    color: '#FFFFFF',
    fontWeight: 'bold',
    marginLeft: '166px'
  }

}

export default RemainingFuelComponent
